import { validCpf } from "../../services/helpers";
export * from '../../utils'

export function rawMsisdn(msisdn) {
  msisdn = msisdn.replace(/\D/g, "");

  if (msisdn.length <= 11) {
    return `55${msisdn}`;
  }

  return msisdn;
}

export function parseMsisdn(rawMsisdn) {
  if (!rawMsisdn) return rawMsisdn;

  let msisdn = rawMsisdn.replace(/\D/g, "");

  if (msisdn.length > 11) {
    msisdn = msisdn.slice(2, 13);
  }

  return `(${msisdn.slice(0, 2)}) ${msisdn.slice(2, 7)}-${msisdn.slice(7)}`;
}


export function validateCard(data) {
  let errorMessages = {};

  if (data.number?.trim() === "" || data.number?.length < 12) {
    errorMessages.number = "Número do cartão inválido";
  }

  if (data.name?.trim() === "") {
    errorMessages.name = "Nome do titular inválido";
  }

  if (data.expiry?.trim() === "" || data.expiry?.length < 4) {
    errorMessages.expiry = "Data de vencimento inválida";
  }

  if (data.cvv?.trim() === "" || data.cvv?.length < 3) {
    errorMessages.cvv = "CVV inválido";
  }

  if (!validCpf(data.cpf)) {
    errorMessages.cpf = "CPF inválido";
  }

  return errorMessages;
}
